import jquery from 'jquery';
window.$ = window.jQuery = window.jquery = jquery;
